var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper-options"},[_c('a',{staticClass:"item-options",class:{
      '-isMovie': _vm.isMovie,
      'isActive': _vm.isActiveMovie
    },on:{"click":function($event){return _vm.movieClick()}}},[_c('div',{staticClass:"item-options__icon"},[_c('Movie',{staticClass:"image"})],1),_c('p',{staticClass:"name",class:{'isActive': _vm.isActiveMovie}},[_vm._v(" Cinema ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }